<template>
  <div class="card-container agentmanage">
    <common-top-form
      :model="formModel"
      :submitService="submitService"
      :show="false"
      :submitData="submitData"
      @success="onSuccess"
    >
      <el-form-item label="提现时间">
        <el-date-picker
          v-model="formModel.time"
          type="daterange"
          range-separator="至"
          value-format="yyyy-MM-dd"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
        >
        </el-date-picker>
      </el-form-item>
      <el-form-item label="分类">
        <el-checkbox v-model="formModel.checked"></el-checkbox>
      </el-form-item>
    </common-top-form>
    <common-table :data="tableData" ref="commonTable" :isShow="false">
      <el-table-column
        prop="area"
        label="地区"
        min-width="130"
        :formatter="formatterTableData"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="money"
        label="金额(元)"
        min-width="130"
        :formatter="formatterTableData"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="chnName"
        label="通道名称"
        min-width="130"
        :formatter="formatterTableData"
        show-overflow-tooltip
      ></el-table-column>
    </common-table>
  </div>
</template>

<script>
import CommonTopForm from "components/common/CommonTopForm";
import CommonTable from "components/common/CommonTable";
import ChannelService from "service/ChannelService";
import StatisticsService from "service/StatisticsService";
import { encrypt, urlEncode, objKeySort } from "common/js/common-utils";
import { loadMixin, dialogMixin } from "mixin";
import { mapGetters } from "vuex";
import TimeRange from "service/constant/TimeRange";

export default {
  name: "withdrawal",
  data() {
    return {
      formModel: {
        time: TimeRange.dayRange,
        checked: false,
      },
      spanArr: [],
      tableData: [],
      submitService: StatisticsService.getWithdrawalList,
    };
  },
  mixins: [loadMixin, dialogMixin],
  components: {
    CommonTopForm,
    CommonTable,
  },
  mounted() {
    this.getList();
  },
  computed: {
    submitData() {
      if (this.formModel.time == null || this.formModel.time == "") {
        this.formModel.time = [];
      }
      const params = {
        black: this.formModel.checked == true ? "1" : "0",
      };
      if (this.formModel.time.length) {
        params.startDate = this.formModel.time[0];
        params.endDate = this.formModel.time[1];
      }
      return params;
    },
    ...mapGetters(["serverType", "tatId", "userId"]),
  },
  methods: {
    getList() {
      this.doLoad(
        this.submitService,
        this.submitData,
        (res) => {
          this.onSuccess(res);
        },
        "信息获取失败"
      );
    },
    onSuccess(data) {
      this.doCheck(data, (res) => {
        const result = res.contents;
        this.tableData = result;
      });
    },
  },
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/view/page/StatisticsManage/Withdrawal.vue